// extracted by mini-css-extract-plugin
module.exports = {"card":"postcard-module--card--3U2NC","info":"postcard-module--info--3mBOK","link":"postcard-module--link--21X6J","linkTitle":"postcard-module--linkTitle--jDHWv"};